import * as types from '../../mutation-types';
import dbConnector from '../../api/dbConnector';

const state = {
  all: []
}

const getters = {
  trainingsPages: state => state.all
}

const actions = {
  getTrainingPages ({commit}, cb){
    dbConnector.getTrainingPages(traininsPages => {
      commit(types.RECEIVE_TRAININGS_PAGES, {traininsPages})
      if (cb) cb()
    })
  }
}

const mutations = {
  [types.RECEIVE_TRAININGS_PAGES] (state, {traininsPages}) {
    state.all = traininsPages
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
